<template>
  <div class="sidebar-layout-help">
    <h3
      class="sidebar-layout-help__title text-heading-s"
      v-text="liquid.helpTitle"
    />

    <p
      class="sidebar-layout-help__description text-body-2xs"
      v-text="liquid.helpCopy"
    />

    <ul class="sidebar-layout-help__list">
      <li>
        <button
          class="sidebar-layout-help__item"
          @click="triggerChat"
        >
          <span class="sidebar-layout-help__item-title">
            <icon-chat />
            <p
              class="sidebar-layout-help__item-title-text text-body-2xs-bold"
              v-text="liquid.helpChatTitle"
            />
          </span>

          <span
            class="sidebar-layout-help__item-description text-body-3xs"
            v-text="liquid.helpChatCopy"
          />
        </button>
      </li>

      <li>
        <component
          :is="liquid.helpMessageUrl ? 'a' : 'div'"
          class="sidebar-layout-help__item"
          :href="liquid.helpMessageUrl"
        >
          <div class="sidebar-layout-help__item-title">
            <icon-mail />
            <p
              class="sidebar-layout-help__item-title-text text-body-2xs-bold"
              v-text="liquid.helpMessageTitle"
            />
          </div>

          <p
            class="sidebar-layout-help__item-description text-body-3xs"
            v-text="liquid.helpMessageCopy"
          />
        </component>
      </li>

      <li>
        <component
          :is="liquid.helpPhoneUrl ? 'a' : 'div'"
          class="sidebar-layout-help__item"
          :href="liquid.helpPhoneUrl"
        >
          <div class="sidebar-layout-help__item-title">
            <icon-phone />
            <p
              class="sidebar-layout-help__item-title-text text-body-2xs-bold"
              v-text="liquid.helpPhoneTitle"
            />
          </div>

          <p
            class="sidebar-layout-help__item-description text-body-3xs"
            v-text="liquid.helpPhoneCopy"
          />
        </component>
      </li>
    </ul>
  </div>
</template>

<script>

/**
 * Vue: Sidebar layout help (sidebar-layout-help)
 * -----------------------------------------------------------------------------
 * Component that displays help content in the sidebar layout .
 *
 */
import IconChat from '~icons/misc/chat.svg'
import IconMail from '~icons/misc/mail.svg'
import IconPhone from '~icons/misc/phone.svg'

export default {
  name: 'SidebarLayoutHelp',

  components: {
    IconChat,
    IconMail,
    IconPhone,
  },

  props: {
    liquid: {
      type: Object,
      default: () => ({}),
    },
  },

  methods: {

    /**
     * Trigger the chat box to open.
     * - Triggers Gorgias Chat open if it's available on the page.
     */
     triggerChat() {
      if (window?.GorgiasChat?.open) {
        window.GorgiasChat.open()
      }
    },
  },
}
</script>

<style lang="scss">
@import './sidebar-layout-help';
</style>
